module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJklEQVQ4T2NgGBTgnKDaf3LwcDLgP5lgEBnA0B74nyw8nAwY0gAAte1/UPay07MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/HU.png
// module id = 1163
// module chunks = 0